module.exports = __webpack_public_path__ + "img/vesper4.22729aab.jpg";